import React, { useEffect } from "react";
import { Instagram, ArrowUpRight } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { IMAGES, CLINIC } from "../mock";

// Unique featured Instagram posts (deduped from provided links).
const POSTS = [
  "https://www.instagram.com/p/DAuYdw2P2UT/",
  "https://www.instagram.com/p/C-I9cWOSbcb/",
  "https://www.instagram.com/p/C7Uz9wyyMQ-/",
  "https://www.instagram.com/p/C0M22cfPUoG/",
  "https://www.instagram.com/p/C0AS3oLvyAk/",
  "https://www.instagram.com/p/Cy9TW7kSlNt/",
  "https://www.instagram.com/p/Cyn9ZVeL2k0/",
  "https://www.instagram.com/p/CyecW_IvXnK/",
  "https://www.instagram.com/p/CyRTdOIPaHU/",
  "https://www.instagram.com/p/Cwk084oxJRB/",
  "https://www.instagram.com/p/CwSg6KBRNbL/",
  "https://www.instagram.com/p/C3RBp3yv9D9/",
];

function loadInstagram() {
  return new Promise((resolve) => {
    if (window.instgrm) return resolve();
    const existing = document.getElementById("ig-embed-script");
    if (existing) {
      existing.addEventListener("load", () => resolve());
      return;
    }
    const s = document.createElement("script");
    s.id = "ig-embed-script";
    s.src = "https://www.instagram.com/embed.js";
    s.async = true;
    s.onload = () => resolve();
    document.body.appendChild(s);
  });
}

export default function Results() {
  useReveal();

  useEffect(() => {
    let cancelled = false;
    const process = () => {
      if (!cancelled && window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
      }
    };
    loadInstagram().then(process);
    const t1 = setTimeout(process, 1200);
    const t2 = setTimeout(process, 3000);
    return () => {
      cancelled = true;
      clearTimeout(t1);
      clearTimeout(t2);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="pt-20">
      {/* Hero */}
      <section className="relative py-32 bg-charcoal overflow-hidden">
        <div className="absolute inset-0 opacity-40">
          <img src={IMAGES.hairGlossy} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/70 to-charcoal/40" />
        </div>
        <div className="relative z-10 max-w-[1300px] mx-auto px-6 text-center">
          <span className="eyebrow text-gold">Real Results</span>
          <h1 className="font-display text-5xl lg:text-6xl font-light text-cream mt-5 leading-tight">
            Straight from our <span className="italic text-gold">Instagram</span>
          </h1>
          <p className="font-sans text-cream/70 max-w-xl mx-auto mt-6 leading-relaxed">
            A curated look at real treatments and transformations, shared by our team on social.
          </p>
          <a
            href={CLINIC.socials.instagram}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 btn-gold mt-8"
          >
            <Instagram size={16} /> Follow @aesthetix.md
          </a>
        </div>
      </section>

      {/* Instagram grid */}
      <section className="bg-cream py-24">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="flex items-center justify-center gap-3 mb-14 reveal">
            <span className="gold-rule" />
            <span className="eyebrow text-gold">Featured Posts</span>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center">
            {POSTS.map((url) => (
              <div key={url} className="w-full flex justify-center reveal">
                <blockquote
                  className="instagram-media"
                  data-instgrm-permalink={url}
                  data-instgrm-version="14"
                  style={{
                    margin: "0 auto",
                    maxWidth: 540,
                    width: "100%",
                    minWidth: 300,
                    background: "#fff",
                    border: 0,
                    borderRadius: 3,
                    boxShadow: "0 20px 45px -25px rgba(20,17,13,0.35)",
                  }}
                >
                  <a href={url} target="_blank" rel="noreferrer" className="block p-8 text-center">
                    <span className="font-display text-xl text-ink">View this post on Instagram</span>
                  </a>
                </blockquote>
              </div>
            ))}
          </div>

          <div className="text-center mt-16 reveal">
            <a
              href={CLINIC.socials.instagram}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 btn-outline-dark"
            >
              See more on Instagram <ArrowUpRight size={15} />
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
